import { useRef } from "react";
import alphabet from "../../constant-value/alphaet.json";
import styles from "./pelakEdit.module.css";

const PelakEdit = ({ formik }) => {

  const {
    values,
    errors,
    touched,
    setFieldValue,
    setFieldTouched,
  } = formik;

  const part1Ref = useRef(null);
  const part2Ref = useRef(null);
  const part3Ref = useRef(null);
  const part4Ref = useRef(null);


  const plateError =
  (touched.pelak1 && errors.pelak1) ||
  (touched.pelak2 && errors.pelak2) ||
  (touched.pelak3 && errors.pelak3) ||
  (touched.pelak4 && errors.pelak4);

  // return (
  //   <>
  //     <div
  //       className={`${styles.pelak} ${
  //         (errors.pelak1 && touched.pelak1) ||
  //         (errors.pelak2 && touched.pelak2) ||
  //         (errors.pelak3 && touched.pelak3) ||
  //         (errors.pelak4 && touched.pelak4)
  //           ? styles.pelakError
  //           : ""
  //       }`}
  //     >

  //       {/* ستون آبی */}

  //       <div className={styles.blue}>

  //         <div className={styles.flag}>
  //           <div className={styles.green}></div>
  //           <div className={styles.white}></div>
  //           <div className={styles.red}></div>
  //         </div>

  //         <div className={styles.irText}>
  //           <span>I.R.</span>
  //           <span>IRAN</span>
  //         </div>

  //       </div>

  //       {/* وسط */}

  //       <div className={styles.main}>

  //         <input
  //           ref={part1Ref}
  //           id="pelak1"
  //           name="pelak1"
  //           maxLength={2}
  //           inputMode="numeric"
  //           value={values.pelak1}
  //           onChange={(e) => {
  //             const value = e.target.value.replace(/\D/g, "");       
  //             setFieldValue("pelak1", value);       
  //           }}
  //           // onChange={(e) =>
  //           //   setFieldValue("pelak1", e.target.value)
  //           // }
  //           onBlur={() =>
  //             setFieldTouched("pelak1", true)
  //           }
  //           className={styles.number}
  //         />

  //         <select
  //           ref={part2Ref}
  //           id="pelak2"
  //           name="pelak2"
  //           value={values.pelak2}
  //           onChange={(e) =>
  //             setFieldValue("pelak2", e.target.value)
  //           }
  //           onBlur={() =>
  //             setFieldTouched("pelak2", true)
  //           }
  //           className={styles.letter}
  //         >
  //           {
  //             alphabet.map(item=>(
  //               <option
  //                 key={item.id}
  //                 value={item.id}
  //               >
  //                 {item.name}
  //               </option>
  //             ))
  //           }

  //         </select>

  //         <input
  //           ref={part3Ref}
  //           id="pelak3"
  //           name="pelak3"
  //           maxLength={3}
  //           inputMode="numeric"
  //           value={values.pelak3}
  //           onChange={(e) => {
  //             const value = e.target.value.replace(/\D/g, "");       
  //             setFieldValue("pelak3", value);       
  //           }}
  //           // onChange={(e) =>
  //           //   setFieldValue("pelak3", e.target.value)
  //           // }
  //           onBlur={() =>
  //             setFieldTouched("pelak3", true)
  //           }
  //           className={styles.number}
  //         />

  //       </div>

  //       {/* ایران */}

  //       <div className={styles.iran}>
  //         <span>
  //           ایران
  //         </span>
  //         <input
  //           ref={part4Ref}
  //           id="pelak4"
  //           name="pelak4"
  //           maxLength={2}
  //           inputMode="numeric"
  //           value={values.pelak4}
  //           onChange={(e) => {
  //             const value = e.target.value.replace(/\D/g, "");       
  //             setFieldValue("pelak4", value);       
  //           }}
  //           // onChange={(e) =>
  //           //   setFieldValue("pelak4", e.target.value)
  //           // }
  //           onBlur={() =>
  //             setFieldTouched("pelak4", true)
  //           }
  //           className={styles.code}
  //         />

  //       </div>
  //     </div>
  //     <div className={styles.errorMessage}>
  //        {(
  //           (touched.pelak1 && errors.pelak1) ||
  //           (touched.pelak2 && errors.pelak2) ||
  //           (touched.pelak3 && errors.pelak3) ||
  //           (touched.pelak4 && errors.pelak4)
  //         ) && (
  //           <div className={styles.errorMessage}>
  //             {errors.pelak1 ||
  //             errors.pelak2 ||
  //             errors.pelak3 ||
  //             errors.pelak4}
  //           </div>
  //         )}
  //     </div>
  //   </>
  // );

  return (
    <div className={styles.wrapper} >
      <div
        className={`${styles.pelak} ${
          plateError ? styles.pelakError : ""
        }`}
      >

        {/* ستون آبی */}

        <div className={styles.blue}>

          <div className={styles.flag}>
            <div className={styles.green}></div>
            <div className={styles.white}></div>
            <div className={styles.red}></div>
          </div>

          <div className={styles.irText}>
            <span>I.R.</span>
            <span>IRAN</span>
          </div>

        </div>

        {/* وسط */}

        <div className={styles.main}>

          <input
            ref={part1Ref}
            id="pelak1"
            name="pelak1"
            maxLength={2}
            inputMode="numeric"
            value={values.pelak1}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, "");       
              setFieldValue("pelak1", value);       
            }}
            // onChange={(e) =>
            //   setFieldValue("pelak1", e.target.value)
            // }
            onBlur={() =>
              setFieldTouched("pelak1", true)
            }
            className={styles.number}
          />

          <select
            ref={part2Ref}
            id="pelak2"
            name="pelak2"
            value={values.pelak2}
            onChange={(e) =>
              setFieldValue("pelak2", e.target.value)
            }
            onBlur={() =>
              setFieldTouched("pelak2", true)
            }
            className={styles.letter}
          >
            {
              alphabet.map(item=>(
                <option
                  key={item.id}
                  value={item.id}
                >
                  {item.name}
                </option>
              ))
            }

          </select>

          <input
            ref={part3Ref}
            id="pelak3"
            name="pelak3"
            maxLength={3}
            inputMode="numeric"
            value={values.pelak3}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, "");       
              setFieldValue("pelak3", value);       
            }}
            // onChange={(e) =>
            //   setFieldValue("pelak3", e.target.value)
            // }
            onBlur={() =>
              setFieldTouched("pelak3", true)
            }
            className={styles.number}
          />

        </div>

        {/* ایران */}

        <div className={styles.iran}>
          <span>
            ایران
          </span>
          <input
            ref={part4Ref}
            id="pelak4"
            name="pelak4"
            maxLength={2}
            inputMode="numeric"
            value={values.pelak4}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, "");       
              setFieldValue("pelak4", value);       
            }}
            // onChange={(e) =>
            //   setFieldValue("pelak4", e.target.value)
            // }
            onBlur={() =>
              setFieldTouched("pelak4", true)
            }
            className={styles.code}
          />

        </div>
      </div>

      {plateError && (
        <div className={styles.errorMessage}>
          {plateError}
        </div>
      )}
    </div>
  );
};

export default PelakEdit;